<template>
    <el-button size="small"
               :disabled="disabled"
               @click="toggleState">
        <span class="icon-wrapper">
            <i class="fas fa-arrow-left"
               v-if="isInbound"></i>
            <i class="fas fa-arrows-alt-h"
               v-else></i>
        </span>
    </el-button>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false, // Bi-directional as default
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        isInbound() {
            return this.value
        }
    },
    methods: {
        toggleState() {
            this.$emit('input', !this.value)
        },
    },
}
</script>

<style scoped>
.icon-wrapper {
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    line-height: 1.2em;
    text-align: center;
}
</style>
